import { createSlice } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { CurrentDate } from '../../types/state';

const initialState: CurrentDate = {
  data: null,
  fetchingStatusDate: false,
  error: null
};

export const currentDate = createSlice({
  name: NameSpace.Date,
  initialState,
  reducers: {
    fetchCurrentDateRequest: (state) => {
      state.fetchingStatusDate = true;
      state.error = null;
    },
    fetchCurrentDateSuccess: (state, action) => {
      state.fetchingStatusDate = false;
      state.data = action.payload;
    },
    fetchCurrentDateFailure: (state, action) => {
      state.fetchingStatusDate = false;
      state.error = action.payload;
    },
  },
});

export const { fetchCurrentDateRequest, fetchCurrentDateSuccess, fetchCurrentDateFailure } = currentDate.actions;
